module.exports = __webpack_public_path__ + "static/media/IconTemplates_-24.2e1e0367.svg";